import {
  COMPLETE_REQUIRED_INFO_ABOVE,
  ORDERING_NOT_AVAILABLE
} from 'constants/menu/ctaName';
import { QUANTITY } from 'helpers/forms/menuItem';
import { getQuantityFieldTotal } from 'helpers/forms/getQuantityFieldTotal';
import { PRODUCT_VARIANT_FIELD_NAME } from 'constants/menu/menuItemDetailForm';

/**
 * This method determines if a user made selections on all the
 * required fields. It looks through all variant inputs and make
 * sure every variant meets the selection requirements.
 * Possible Selection scenarios considered:
 * 1) users did not make any selection
 * 2) User made a selection but it it does not meet the min. selection requirement
 * 3) If the selectedfield is a radio button and the user made a selection
 * 4) If the selected fields is a checkbox with some selections
 */

export const getAreRequiredFieldsSelected = (
  values,
  fields,
  shouldCheckProductVariantsField = false
) => {
  const requiredModifiersAreSelected = fields.every(field => {
    const minQty = parseInt(field.min_qty);
    const fieldType = field.field_type;
    const selectedField = values[field.slug];
    if (minQty >= 1) {
      /* case 1 */
      if (
        !selectedField ||
        (Object.keys(selectedField).length === 0 &&
          Object.getPrototypeOf(selectedField) === Object.prototype)
      ) {
        return false;
      }
      /* case 2 specifically for quantity as object length does not necessarily
       have to be equal to minQty */
      if (fieldType === QUANTITY) {
        const selectedFieldValues = Object.values(selectedField);
        return getQuantityFieldTotal(selectedFieldValues) >= minQty;
      }
      /* case 3 */
      if (Object.values(selectedField).length < minQty) {
        return false;
      }
      /* case 4 */
      if (selectedField && typeof selectedField !== 'object') {
        return true;
      }
      /* case 5 */
      if (
        selectedField &&
        typeof selectedField === 'object' &&
        Object.keys(selectedField).length >= minQty
      ) {
        const selectedFieldValues = Object.values(selectedField);
        return selectedFieldValues.filter(value => value).length >= minQty;
      }
    }
    return true;
  });

  let requiredFieldsAreSelected;
  if (shouldCheckProductVariantsField) {
    const requiredProductVariantIsSelected = !!values[
      PRODUCT_VARIANT_FIELD_NAME
    ];
    requiredFieldsAreSelected =
      requiredModifiersAreSelected && requiredProductVariantIsSelected;
  } else {
    requiredFieldsAreSelected = requiredModifiersAreSelected;
  }

  return requiredFieldsAreSelected;
};

export const getAddToCartLabel = (
  requiredFieldsAreSelected,
  isAddingToCart,
  defaultCtaName,
  isSoldOut,
  isPreviewMenuOn = false,
  hasExceededSpendingLimit = false
) => {
  if (isPreviewMenuOn) {
    return ORDERING_NOT_AVAILABLE;
  }

  if (isSoldOut) {
    return 'SOLD OUT';
  }
  if (isAddingToCart) {
    return 'Adding to cart';
  }

  if (hasExceededSpendingLimit) {
    return COMPLETE_REQUIRED_INFO_ABOVE;
  }

  if (requiredFieldsAreSelected) {
    return defaultCtaName;
  }

  return COMPLETE_REQUIRED_INFO_ABOVE;
};
